import React from "react";
import api from "../../../Api/apiAxios";
import { Table } from "react-bootstrap";
import Loading from "../../../Components/Loading";
import { MyContext } from "../../../Context/MyContext";
import Mensagem from "../../../Components/Mensagem";
import HeaderPersonalizacoes from "../../../Components/HeaderPersonalizacoes";
import { Paginacao } from "../../../Components/Paginacao";
import styles from "./PersonalizacaoAcessoIndex.module.css";

import ItemStatus from "../../../Components/ItemStatus";
import PersonalizacoesButtons from "../../../Components/PersonalizacoesButtons";
import { TableItemName } from "../../../Components/TableItemName";
import TipoInstalacao from "../../../Components/TipoInstalacao";

const PersonalizacaoAcessoIndex = () => {
    const nivelUsuario = window.localStorage.getItem('nivelUsuario');  
    const idDistribuidor = window.localStorage.getItem('distribuidorId');   

    const { mensagemGlobal, setMensagemGlobal, tipoMensagemGlobal, setTipoMensagemGlobal,
            setListaGlobalClientes, setListaGlobalContratos,
            listaGlobalLicencasBmaAcesso, setListaGlobalLicencasBmaAcesso,
            pesquisaGlobalLicencasBmaAcesso, setPesquisaGlobalLicencasBmaAcesso,
            setDistribuidorIdGlobal, itensPorPagina } = React.useContext(MyContext);

    const [pesquisa, setPesquisa] = React.useState('');
    const [tipoPesquisa, setTipoPesquisa] = React.useState('*');
    const [loading, setLoading] = React.useState(false);
    const [quantidadeLicencas, setQuantidadeLicencas] = React.useState(0);
    const [registroInicial, setRegistroInicial] = React.useState(1);
    const [registroFinal, setRegistroFinal] = React.useState(20);

    const [personalizacoes, setPersonalizacoes] = React.useState([]);

    React.useEffect(() => {
        setListaGlobalClientes(null);    
        setListaGlobalContratos(null);    
        setDistribuidorIdGlobal('');
        
        pesquisaInicial();            

    }, []);    


    async  function pesquisaInicial() { 
      
        setLoading(true); 

        if  (listaGlobalLicencasBmaAcesso !== null) {
            setPersonalizacoes(listaGlobalLicencasBmaAcesso);
            setQuantidadeLicencas(listaGlobalLicencasBmaAcesso.length);   
            setPesquisa(pesquisaGlobalLicencasBmaAcesso);
        }
        else {
            try {
                const response = await api.get(`/LicencaAcesso/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}&regInicial=${registroInicial}&itensPorPagina=${999999}`);   
                var qtdeRegistros = response.data[0].valorPedido;
                setQuantidadeLicencas(qtdeRegistros);             
                
                const response2 = await api.get(`/LicencaAcesso/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}&regInicial=${registroInicial}&itensPorPagina=${itensPorPagina}`);   
                setPersonalizacoes(response2.data); 
            } catch (e) {
                alert(e);
            }
        }
        setLoading(false);       
    }
    
    async function pesquisarClick() {

        var tamanho = pesquisa.length;
        try {
            if  (tamanho > 0 && (tipoPesquisa !== "ns" && tipoPesquisa !== "cliente" && tipoPesquisa !== "distribuidor") && isNaN(pesquisa))
            {
                setMensagemGlobal("Pesquisa Parcial somente para NS, Cliente ou Revenda !");
                setTipoMensagemGlobal("warning");
                return;
            }

            setLoading(true);                  
            setMensagemGlobal(null);
            setPesquisaGlobalLicencasBmaAcesso(null);
            setListaGlobalLicencasBmaAcesso(null);

            if  (tipoPesquisa === "comregistro" || tipoPesquisa === "semregistro")        
            {
                const pesq = tipoPesquisa;
                const response = await api.get(`/LicencaAcesso/parametros-consulta?id=${idDistribuidor}&nivel=${nivelUsuario}&tipo=${tipoPesquisa}&args=${pesq}`);   
                    setPersonalizacoes(response.data);  
            } else  if  (pesquisa.length === 0)  {   

                    const response2 = await api.get(`/LicencaAcesso/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}&regInicial=${registroInicial}&itensPorPagina=${itensPorPagina}`);   
                    setPersonalizacoes(response2.data);   
                } else {
                        const response = await  api.get(`/LicencaAcesso/parametros-consulta?id=${idDistribuidor}&nivel=${nivelUsuario}&tipo=${tipoPesquisa}&args=${pesquisa}`);   
                            setPersonalizacoes(response.data);    
                            setListaGlobalLicencasBmaAcesso(response.data);
                            setPesquisaGlobalLicencasBmaAcesso(pesquisa);
            }
        } catch (e) {
            alert(e);
        } finally {
            setPesquisa('');
            setLoading(false);
        }      
    }

    if  (loading) return <Loading />
                           
    return (
        <section>
          {mensagemGlobal && <Mensagem mensagem={mensagemGlobal} setMensagem={setMensagemGlobal} variant={tipoMensagemGlobal} /> }                                 

           <HeaderPersonalizacoes titulo={"Licenças BmaAcesso"}  
                pesquisa={pesquisa} setPesquisa={setPesquisa}
                tipoPesquisa={tipoPesquisa} setTipoPesquisa={setTipoPesquisa}
                pesquisarClick={pesquisarClick} 
            />

            <Table striped hover responsive size='sm'>
                <thead className={styles.thead}>
                    <tr className={styles.trHead}>
                            <th className={styles.th}>Revenda</th>
                            <th className={styles.th}>Cliente</th>                          
                            <th className={styles.th}>Inscrição</th>                          
                            <th className={styles.th}>NS</th>                        
                            <th className={styles.th}>Versão</th>
                            <th className={styles.th}>Plano</th>
                            <th className={styles.th}>Vertical</th>
                            <th className={styles.th}>Eq.Ad.</th>
                            <th className={styles.th}>Data Reg.</th>
                            <th className={styles.th}>Status</th>
                    </tr>
                </thead>
                <tbody className={styles.tbody}>
                {personalizacoes.map(personalizacao => 
                    <tr key={personalizacao.id} className={styles.trBody}>  
                        <TableItemName title={personalizacao.distribuidor.razaoSocial} />
                        <TableItemName title={personalizacao.razaoSocial} />
                        
                        <td className={styles.inscricao}>{personalizacao.numeroInscricao}</td>
                        <td className={styles.td}>{personalizacao.numeroSerie}</td>  
                        <td className={styles.td}>{personalizacao.versao}</td>

                        <TipoInstalacao tipoInstalacao={personalizacao.tipoInstalacao} tipoComercializacao={personalizacao.tipoComercializacao} tipoLicenciamento={personalizacao.tipoLicenciamento} tipoServico={personalizacao.tipoServicoPedido} />  
                                              
                        {personalizacao.tipoVertical === 0 && <td className={styles.td}>Empresa</td>}
                        {personalizacao.tipoVertical === 1 && <td className={styles.td}>Empresa</td>}
                        {personalizacao.tipoVertical === 2 && <td className={styles.td}>Refeitório</td>}
                        {personalizacao.tipoVertical === 3 && <td className={styles.td}>Academia</td>}
                        {personalizacao.tipoVertical === 4 && <td className={styles.td}>Condomínio</td>}
                        {personalizacao.tipoVertical === 5 && <td className={styles.td}>Hospital</td>}
                        {personalizacao.tipoVertical === 6 && <td className={styles.td}>Escola</td>}
                        {personalizacao.tipoVertical === 7 && <td className={styles.td}>Acesso Go</td>}

                        <td className={styles.td}>{personalizacao.equipamentoAdicional}</td>
                        {personalizacao.dataRegistro ?
                            <td className={styles.td}>
                                 {personalizacao.dataRegistro.substring(8,10)}/ 
                                 {personalizacao.dataRegistro.substring(5,7)}/   
                                 {personalizacao.dataRegistro.substring(0,4)}    
                            </td>
                            :
                            <td className={styles.td}>* * * * * * *</td>
                        }

                        <ItemStatus dataRegistro={personalizacao.dataRegistro} baixadaPorNovaVersao={personalizacao.baixadaPorNovaVersao}  />  
                                                                   
                        <PersonalizacoesButtons 
                            nivelUsuario={nivelUsuario} 
                            personalizacao={personalizacao} 
                            pesquisarClick={pesquisarClick} 
                            isAcesso={true}
                            editarUrl={`/editarpersonalizacaoacesso/${personalizacao.id}`}
                            bloquearUrl={`/LicencaAcesso/atualizar-bloqueio?id=${personalizacao.id}`}
                            liberarChaveUrl={`/LicencaAcesso/resetar-chave?id=${personalizacao.id}`}
                            liberarPersonalizacaoUrl={`/LicencaAcesso/liberar-novo-registro?id=${personalizacao.id}`}
                            viewUrl={`/viewpersonalizacaoacesso/${personalizacao.id}`}
                        />
                    </tr>
                )}

                </tbody>
                <tfoot>
                    <tr>
                      <Paginacao 
                            setRegistroFinal={setRegistroFinal}
                            setRegistroInicial={setRegistroInicial}
                            setRegistrosData={setPersonalizacoes}
                            registroInicial={registroInicial}     
                            registroFinal={registroFinal}                                                                 
                            quantidadeRegistros={quantidadeLicencas}
                            itensPorPagina={itensPorPagina}
                            urlPesquisa={`/LicencaAcesso/consulta-paginada?id=${idDistribuidor}&nivel=${nivelUsuario}`} 
                        />  
                    </tr>
                </tfoot>                    

            </Table>

        </section>
    )

}

export default PersonalizacaoAcessoIndex;